import React from 'react'
import { Carousel } from 'antd';

import './view.css'

export default function ViewIndex() {
    const items = [
        {
            key: 1,
            title: '課程地圖P1',
            content: '課程地圖P1是各系所衡量學生學習成效及未來出路的教學設計，為同學未來的職涯發展規劃相關學習課程及活動，並讓同學們在學習上更具方向感，並可增進學習動機及學習成效。'
        },
        {
            key: 2,
            title: '課程地圖P2',
            content: '課程地圖P2是各系所衡量學生學習成效及未來出路的教學設計，為同學未來的職涯發展規劃相關學習課程及活動，並讓同學們在學習上更具方向感，並可增進學習動機及學習成效。'
        },
        {
            key: 3,
            title: '課程地圖P3',
            content: '課程地圖P3是各系所衡量學生學習成效及未來出路的教學設計，為同學未來的職涯發展規劃相關學習課程及活動，並讓同學們在學習上更具方向感，並可增進學習動機及學習成效。'
        },
    
    ]

    return (
        <div id="index" className="indexBlock">
            <Carousel>
                {
                    items.map((item) => {
                        return (
                            <div className="container-fluid" key = {item.key}>
                                <div className="content" >
                                   {item.content}
                                </div>
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}